import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VehicleUIEventsService {

  constructor() { }

  isRoutesTabSelected$ = new Subject<boolean>();
}
